import { useQuery } from "@tanstack/react-query";
import { artefactsApi } from "../api/artefacts";

export const useFetchArtefacts = (projectId: string | undefined, page: number, limit: number, searchKey: string | null) => {

    const { data, isFetching, isPending, isError, refetch } = useQuery({
        queryKey: ["artefact-document", projectId, page, limit, searchKey],
        queryFn: () => artefactsApi.fetchArtefacts({
            params: {
                page, limit,
                search_term: searchKey,
                project_id: projectId
            }
        }),
    });

    return {
        artefactsData: data?.data?.rows,
        artefactsPagination: data?.data?.pagination,
        isPending, isFetching, isError,
        refetch: refetch
    }

};